import { Vendor } from "./type"
import { actionCreatorFactory } from "typescript-fsa"

const actionCreator = actionCreatorFactory()

export const setVendorAction = actionCreator<Vendor>("SET_VENDOR")
